// San Juan Tour Data and Constants

// Image constants
export const PLACEHOLDER_IMAGE = "https://picsum.photos/1200/800?blur=1";
export const STEP1_IMAGE  = "/images/image%201.png";
export const STEP2_IMAGE  = "/images/image%202.png";
export const STEP3_IMAGE  = "/images/image%203.png";
export const STEP4_IMAGE  = "/images/image%204.png";
export const STEP5_IMAGE  = "/images/image%205.png";
export const STEP6_IMAGE  = "/images/image%206.png";
export const STEP7_IMAGE  = "/images/image%207.png";
export const STEP8_IMAGE  = "/images/image%208.png";
export const STEP9_IMAGE  = "/images/image%209.png";
export const STEP10_IMAGE = "/images/image%2010.png";
export const STEP11_IMAGE = "/images/image%2011.png";
export const STEP12_IMAGE = "/images/image%2012.png";

// Map overrides for specific locations
export const MAP_OVERRIDES = {
  "Church of Saint Francis of Assisi": {
    apple: "301 Calle de San Francisco, San Juan, PR  00901",
  },
  "La Perla Overlook": {
    apple: "280 Norzagaray St, San Juan, PR",
    google: "304 Calle Norzagaray, San Juan, 00901, Puerto Rico",
  },
  "Callejón de la Puerta con la Bandera": {
    apple: "La Puerta de la Bandera",
  },
  "El Morro (Lawn/Lighthouse View)": {
    apple: "18.468344, -66.121121",
    google: "18.468344, -66.121121",
  },
  "La Rogativa": {
    apple: "Plazuela de la Rogativa",
  },
};

// For now, import the tour data from the original location
// TODO: Move the full TIB_SAN_JUAN data here to complete the refactoring
export const TIB_SAN_JUAN = null; // Placeholder - will be populated from App.js

// Recommendations by step
export const RECOMMENDATIONS_BY_STEP = {
  "step-1": [
    {
      id: "cafe-berlin",
      name: "Café Berlin",
      category: "Cafe • Brunch",
      categoryEs: "Café • Desayuno",
      blurb:
        "Right on Plaza Colón — locals love the refreshing lemonade and hearty breakfasts.",
      blurbEs:
        "Justo en Plaza Colón — los locales adoran la limonada refrescante y los desayunos abundantes.",
      photo: "/images/recommendations/cafe-berlin.jpg",
      address: "407 Calle San Francisco, Old San Juan, San Juan, PR 00901",
      mapsUrl:
        "https://maps.google.com/?q=Caf%C3%A9+Berlin+407+Calle+San+Francisco+San+Juan+PR+00901",
    },
  ],
  "step-2": [
    {
      id: "chocobar-cortes",
      name: "Chocobar Cortés",
      category: "Cafe • Dessert",
      categoryEs: "Café • Postres",
      blurb:
        "Silky Puerto Rican hot chocolate or the famous chocolate grilled cheese.",
      blurbEs:
        "Chocolate caliente puertorriqueño sedoso o el famoso sándwich de queso con chocolate.",
      photo: "/images/recommendations/chocobar-cortes.jpg",
      address: "210 Calle de San Francisco, San Juan, PR 00901",
      mapsUrl:
        "https://maps.google.com/?q=Chocobar+Cort%C3%A9s+210+Calle+de+San+Francisco+San+Juan+PR+00901",
    },
  ],
  "step-3": [],
  "step-4": [
    {
      id: "la-verguenza",
      name: "Bar La Vergüenza",
      category: "Rooftop • Cocktails",
      categoryEs: "Terraza • Cócteles",
      blurb:
        "Ocean views, a frosty Vergüenza Colada, and crispy pork empanadas.",
      blurbEs:
        "Vistas al mar, una Vergüenza Colada helada y empanadillas de cerdo crujientes.",
      photo: "/images/recommendations/bar-la-verguenza.jpg",
      address: "280 Calle Norzagaray, San Juan, PR 00901",
      mapsUrl:
        "https://maps.google.com/?q=Bar+La+Verg%C3%BCenza+280+Calle+Norzagaray+San+Juan+PR+00901",
    },
  ],
  "step-5": [
    {
      id: "la-factoria",
      name: "La Factoría",
      category: "Cocktails",
      categoryEs: "Cócteles",
      blurb:
        "Named one of North America's 50 Best Bars — hidden rooms, expert drinks.",
      blurbEs:
        "Nombrado uno de los 50 Mejores Bares de Norteamérica — salas ocultas, tragos de expertos.",
      photo: "/images/recommendations/la-factoria.jpg",
      address: "148 Calle San Sebastián, San Juan, PR 00901",
      mapsUrl:
        "https://maps.google.com/?q=La+Factor%C3%ADa+148+Calle+San+Sebasti%C3%A1n+San+Juan+PR+00901",
    },
  ],
  "step-6": [
    {
      id: "cafe-don-ruiz",
      name: "Café Don Ruiz",
      category: "Coffee • Café",
      categoryEs: "Café",
      blurb:
        "Single-origin Puerto Rican espresso and toasted mallorcas inside Ballajá.",
      blurbEs:
        "Espresso puertorriqueño de origen único y mallorcas tostadas dentro de Ballajá.",
      photo: "/images/recommendations/cafe-don-ruiz.jpg",
      address: "Cuartel de Ballajá, Cll. Norzagaray, San Juan, PR 00901",
      mapsUrl:
        "https://maps.google.com/?q=Caf%C3%A9+Don+Ruiz+Cuartel+de+Ballaj%C3%A1+San+Juan+PR+00901",
    },
  ],
  "step-7": [],
  "step-8": [
    {
      id: "patio-del-nispero",
      name: "Hotel El Convento — Patio del Níspero",
      category: "Courtyard • Restaurant",
      categoryEs: "Patio • Restaurante",
      blurb:
        "One block inland — passion-fruit mojito or lobster-mango mofongo in a historic courtyard.",
      blurbEs:
        "A una cuadra tierra adentro — mojito de parcha o mofongo de langosta con mango en un patio histórico.",
      photo: "/images/recommendations/hotel-el-convento.jpg",
      address: "100 Calle del Cristo, San Juan, PR 00901",
      mapsUrl:
        "https://maps.google.com/?q=Patio+del+N%C3%ADspero+100+Calle+del+Cristo+San+Juan+PR+00901",
    },
  ],
  "step-9": [
    {
      id: "cafe-caleta",
      name: "Café Caleta",
      category: "Cafe • Puerto Rican",
      categoryEs: "Café • Puertorriqueño",
      blurb:
        "Creative Puerto Rican fare and craft coffee in a cozy nook on historic Caleta de San Juan.",
      blurbEs:
        "Cocina puertorriqueña creativa y café artesanal en un rincón acogedor de la histórica Caleta de San Juan.",
      photo: "/images/recommendations/cafe-caleta.jpg",
      address: "Antigua Casa Cabildo, 78 Caleta de San Juan, San Juan, PR 00901",
      mapsUrl:
        "https://maps.google.com/?q=Caf%C3%A9+Caleta+78+Caleta+de+San+Juan+San+Juan+PR+00901",
    },
  ],
  "step-10": [],
  "step-11": [
    {
      id: "princesa-cocina-cultura",
      name: "Princesa — Cocina Cultura",
      category: "Puerto Rican • Garden",
      categoryEs: "Puertorriqueño • Jardín",
      blurb:
        "Herb-scented ron con coco and octopus mofongo along the promenade.",
      blurbEs:
        "Ron con coco aromático y mofongo de pulpo a lo largo del paseo.",
      photo: "/images/recommendations/princesa-cocina-cultura.jpg",
      address: "Paseo de la Princesa s/n, San Juan, PR 00901",
      mapsUrl:
        "https://maps.google.com/?q=Princesa+Cocina+Cultura+Paseo+de+la+Princesa+San+Juan+PR+00901",
    },
  ],
  "step-12": [],
};
